import React from 'react';

const HomeFact2 = props => {
  return (
    <div>

    </div>
  )
}

export default HomeFact2